import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function generateProcessConfigToken(processId, accessMode) {
  return request.post(`/process/config/generateToken/${processId}/${accessMode}`);
}

export async function queryProcessConfigSummary(processId, versionId, token) {
  return request(`/process/config/summary/${processId}/${versionId}?token=${token}`, {
    method: 'GET',
  });
}

export async function queryActionsDiagram(processId, versionId, token) {
  return request(`/process/config/${processId}/${versionId}/diagram?token=${token}`, {
    method: 'GET',
  });
}

export async function queryListPermissions(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySavePermission(payload) {
  return request.post(`/process/${payload.routeAdd}/${payload.id}`, {
    data: payload.data,
  });
}

export async function queryProcessById(processId) {
  return request(`/process/${processId}`, {
    method: 'GET',
  });
}

export async function queryProcessVersions(processId) {
  return request(`/process/config/${processId}/versions`, {
    params: {
      $select: 'id,number,current,published',
    },
  });
}
